(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lox-aroma-guide"]) return;
  try {
    
if (!customElements.get('lox-product-guide')) {
 class LoxProductGuide extends HTMLElement {
  connectedCallback() {
   if (this.dataset.enhanced) return;
   this.dataset.enhanced = 'true';
   this.querySelectorAll('[data-lox-slider]').forEach(slider => {
    const track = slider.querySelector('.lox-track');
    slider.querySelectorAll('[data-lox-scroll]').forEach(button => {
     button.addEventListener('click', () => {
      const slide = track.querySelector('.lox-slide');
      const gap = parseFloat(getComputedStyle(track).gap) || 16;
      const step = slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({ left: step * Number(button.dataset.loxScroll), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
     });
    });
   });
   this.querySelectorAll('[data-lox-tabs]').forEach(tabs => {
    const buttons = [...tabs.querySelectorAll('[data-lox-tab]')];
    const panels = [...tabs.querySelectorAll('[data-lox-panel]')];
    tabs.querySelector('.lox-tab-list').setAttribute('role', 'tablist');
    const activate = index => {
     buttons.forEach((button, position) => {
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', String(position === index));
      button.tabIndex = position === index ? 0 : -1;
      panels[position].hidden = position !== index;
      panels[position].setAttribute('role', 'tabpanel');
     });
    };
    buttons.forEach((button, index) => {
     button.addEventListener('click', () => activate(index));
     button.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
      if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = buttons.length - 1;
      if (next !== undefined) {
       event.preventDefault();
       activate(next);
       buttons[next].focus();
       buttons[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
     });
    });
    activate(0);
   });
  }
 }
 customElements.define('lox-product-guide', LoxProductGuide);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lox-bobble-guide"]) return;
  try {
    
if (!customElements.get('lox-product-guide')) {
 class LoxProductGuide extends HTMLElement {
  connectedCallback() {
   if (this.dataset.enhanced) return;
   this.dataset.enhanced = 'true';
   this.querySelectorAll('[data-lox-slider]').forEach(slider => {
    const track = slider.querySelector('.lox-track');
    slider.querySelectorAll('[data-lox-scroll]').forEach(button => {
     button.addEventListener('click', () => {
      const slide = track.querySelector('.lox-slide');
      const gap = parseFloat(getComputedStyle(track).gap) || 16;
      const step = slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({ left: step * Number(button.dataset.loxScroll), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
     });
    });
   });
   this.querySelectorAll('[data-lox-tabs]').forEach(tabs => {
    const buttons = [...tabs.querySelectorAll('[data-lox-tab]')];
    const panels = [...tabs.querySelectorAll('[data-lox-panel]')];
    tabs.querySelector('.lox-tab-list').setAttribute('role', 'tablist');
    const activate = index => {
     buttons.forEach((button, position) => {
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', String(position === index));
      button.tabIndex = position === index ? 0 : -1;
      panels[position].hidden = position !== index;
      panels[position].setAttribute('role', 'tabpanel');
     });
    };
    buttons.forEach((button, index) => {
     button.addEventListener('click', () => activate(index));
     button.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
      if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = buttons.length - 1;
      if (next !== undefined) {
       event.preventDefault();
       activate(next);
       buttons[next].focus();
       buttons[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
     });
    });
    activate(0);
   });
  }
 }
 customElements.define('lox-product-guide', LoxProductGuide);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lox-corporate-gifts"] && !Shopify.designMode) return;
  try {
    
if (!window.loxHulkFrameResizeBound) {
  window.loxHulkFrameResizeBound = true;
  window.addEventListener('message', event => {
    if (event.origin !== 'https://formbuilder.hulkapps.com' || !event.data || typeof event.data !== 'object') return;
    document.querySelectorAll('iframe[data-lox-hulk-form]').forEach(frame => {
      if (event.source !== frame.contentWindow || event.data.formid !== frame.dataset.loxHulkForm) return;
      const height = Number(event.data.height);
      if (Number.isFinite(height) && height >= 100 && height <= 12000) frame.style.height = height + 'px';
      if (window.FbThemeAppExtSettingsHash) frame.contentWindow.postMessage(JSON.stringify(window.FbThemeAppExtSettingsHash), event.origin);
      if (event.data.scroll_to) frame.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    });
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lox-corporate-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lox-editorial-home')) {
    customElements.define('lox-editorial-home', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.configureMotion();
        this.motionPreference.addEventListener('change', () => this.configureMotion(), { signal });
        this.rail = this.querySelector('[data-rail]');
        if (!this.rail) return;
        this.previous = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.progress = this.querySelector('[data-rail-progress]');
        this.querySelector('[data-rail-controls]').hidden = false;
        const scheduleUpdate = () => {
          if (this.railFrame) return;
          this.railFrame = requestAnimationFrame(() => {
            this.railFrame = null;
            this.updateRail();
          });
        };
        this.rail.addEventListener('scroll', scheduleUpdate, { passive: true, signal });
        this.previous.addEventListener('click', () => this.moveRail(-1), { signal });
        this.next.addEventListener('click', () => this.moveRail(1), { signal });
        this.rail.addEventListener('keydown', (event) => {
          if (event.target !== this.rail) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            this.moveRail(event.key === 'ArrowLeft' ? -1 : 1);
          } else {
            this.rail.scrollTo({ left: event.key === 'Home' ? 0 : this.rail.scrollWidth, behavior: this.scrollBehavior() });
          }
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('.le-case');
          if (card) this.rail.scrollTo({ left: this.rail.scrollLeft + card.getBoundingClientRect().left - this.rail.getBoundingClientRect().left - parseFloat(getComputedStyle(this.rail).paddingLeft), behavior: 'auto' });
        }, { signal });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(scheduleUpdate);
          this.resizeObserver.observe(this.rail);
        }
        this.updateRail();
      }
      configureMotion() {
        this.revealObserver?.disconnect();
        this.querySelectorAll('.le-pending').forEach((element) => element.classList.remove('le-pending'));
        this.motionEnabled = this.dataset.motion === 'true' && !this.motionPreference.matches;
        this.classList.toggle('le-motion', this.motionEnabled);
        if (!this.motionEnabled || !('IntersectionObserver' in window)) return;
        this.revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.remove('le-pending');
            this.revealObserver.unobserve(entry.target);
          });
        }, { threshold: 0, rootMargin: '0px 0px -35px 0px' });
        this.querySelectorAll('[data-reveal]').forEach((element) => {
          if (element.getBoundingClientRect().top > window.innerHeight) {
            element.classList.add('le-pending');
            this.revealObserver.observe(element);
          }
        });
      }
      scrollBehavior() {
        return this.motionEnabled ? 'smooth' : 'auto';
      }
      moveRail(direction) {
        const card = this.rail.querySelector('.le-case');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).columnGap || 0);
        this.rail.scrollBy({ left: direction * step, behavior: this.scrollBehavior() });
      }
      updateRail() {
        if (!this.rail) return;
        const maximum = this.rail.scrollWidth - this.rail.clientWidth;
        this.previous.disabled = this.rail.scrollLeft <= 2;
        this.next.disabled = this.rail.scrollLeft >= maximum - 2;
        this.progress.style.transform = `scaleX(${Math.min(1, (this.rail.scrollLeft + this.rail.clientWidth) / Math.max(1, this.rail.scrollWidth))})`;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.revealObserver?.disconnect();
        this.resizeObserver?.disconnect();
        if (this.railFrame) cancelAnimationFrame(this.railFrame);
        this.railFrame = null;
        this.querySelectorAll('.le-pending').forEach((element) => element.classList.remove('le-pending'));
      }
    });
  }

(() => {
  'use strict';
  if (customElements.get('lox-stone-anatomy')) return;

  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const identity = () => new Float32Array([1,0,0,0, 0,1,0,0, 0,0,1,0, 0,0,0,1]);
  const multiply = (a, b) => {
    const out = new Float32Array(16);
    for (let c = 0; c < 4; c++) for (let r = 0; r < 4; r++)
      out[c * 4 + r] = a[r] * b[c * 4] + a[4 + r] * b[c * 4 + 1] + a[8 + r] * b[c * 4 + 2] + a[12 + r] * b[c * 4 + 3];
    return out;
  };
  const translate = (x, y, z) => { const m = identity(); m[12] = x; m[13] = y; m[14] = z; return m; };
  const rotate = (x, y, z) => {
    const sx = Math.sin(x), cx = Math.cos(x), sy = Math.sin(y), cy = Math.cos(y), sz = Math.sin(z), cz = Math.cos(z);
    return multiply(multiply(new Float32Array([cy,0,-sy,0, 0,1,0,0, sy,0,cy,0, 0,0,0,1]), new Float32Array([1,0,0,0, 0,cx,sx,0, 0,-sx,cx,0, 0,0,0,1])), new Float32Array([cz,sz,0,0, -sz,cz,0,0, 0,0,1,0, 0,0,0,1]));
  };
  const perspective = (aspect) => {
    const f = 1 / Math.tan(31 * Math.PI / 360), near = .1, far = 30;
    return new Float32Array([f/aspect,0,0,0, 0,f,0,0, 0,0,(far+near)/(near-far),-1, 0,0,2*far*near/(near-far),0]);
  };

  function arch(inset = 0) {
    const r = .77 - inset, floor = -1.05 + inset, cy = .36;
    const points = [[-r, floor], [r, floor], [r, cy]];
    for (let i = 1; i <= 64; i++) {
      const a = Math.PI * i / 64;
      points.push([Math.cos(a) * r, cy + Math.sin(a) * r]);
    }
    return points;
  }
  function newMesh() { return { positions: [], normals: [] }; }
  function tri(mesh, a, b, c, normal) {
    let n = normal;
    if (!n) {
      const u = b.map((v,i) => v-a[i]), v = c.map((s,i) => s-a[i]);
      n = [u[1]*v[2]-u[2]*v[1], u[2]*v[0]-u[0]*v[2], u[0]*v[1]-u[1]*v[0]];
      const len = Math.hypot(...n) || 1; n = n.map(v => v/len);
    }
    mesh.positions.push(...a,...b,...c); mesh.normals.push(...n,...n,...n);
  }
  function quad(mesh,a,b,c,d,n) { tri(mesh,a,b,c,n); tri(mesh,a,c,d,n); }
  function archSolid(depth, bevel = .025) {
    const mesh = newMesh(), outer = arch(), inner = arch(bevel), half = depth/2;
    const rings = [{p:inner,z:-half},{p:outer,z:-half+bevel},{p:outer,z:half-bevel},{p:inner,z:half}];
    for (let k = 0; k < rings.length-1; k++) {
      const a=rings[k],b=rings[k+1];
      for (let i=0;i<a.p.length;i++) {
        const j=(i+1)%a.p.length;
        quad(mesh,[...a.p[i],a.z],[...a.p[j],a.z],[...b.p[j],b.z],[...b.p[i],b.z]);
      }
    }
    for (let i=0;i<inner.length;i++) {
      const j=(i+1)%inner.length;
      tri(mesh,[0,0,half],[...inner[i],half],[...inner[j],half],[0,0,1]);
      tri(mesh,[0,0,-half],[...inner[j],-half],[...inner[i],-half],[0,0,-1]);
    }
    return mesh;
  }

  function archBand(radius, width, z, height) {
    const mesh = newMesh(), cy=.36, bottom=-.88, path=[];
    path.push({x:-radius,y:bottom,nx:-1,ny:0});
    for(let i=0;i<=64;i++) {
      const a=Math.PI-Math.PI*i/64;
      path.push({x:Math.cos(a)*radius,y:cy+Math.sin(a)*radius,nx:Math.cos(a),ny:Math.sin(a)});
    }
    path.push({x:radius,y:bottom,nx:1,ny:0});
    const profile=[[-width*.5,0],[-width*.34,height*.65],[0,height],[width*.34,height*.65],[width*.5,0]];
    for(let i=0;i<path.length-1;i++) for(let k=0;k<profile.length-1;k++) {
      const a=path[i],b=path[i+1],p=profile[k],q=profile[k+1];
      quad(mesh,[a.x+a.nx*p[0],a.y+a.ny*p[0],z+p[1]], [b.x+b.nx*p[0],b.y+b.ny*p[0],z+p[1]], [b.x+b.nx*q[0],b.y+b.ny*q[0],z+q[1]], [a.x+a.nx*q[0],a.y+a.ny*q[0],z+q[1]]);
    }
    return mesh;
  }
  function medallion(z) {
    const mesh=newMesh(),r=.056,y=-.95;
    for(let i=0;i<40;i++) { const a=i*Math.PI/20,b=(i+1)*Math.PI/20; tri(mesh,[0,y,z],[Math.cos(a)*r,y+Math.sin(a)*r,z],[Math.cos(b)*r,y+Math.sin(b)*r,z],[0,0,1]); }
    return mesh;
  }

  const vertexSource = `
    attribute vec3 aPosition; attribute vec3 aNormal;
    uniform mat4 uProjection; uniform mat4 uModel;
    varying vec3 vNormal; varying vec3 vPosition; varying vec3 vLocal;
    void main(){ vec4 p=uModel*vec4(aPosition,1.0); vPosition=p.xyz;vNormal=mat3(uModel)*aNormal;vLocal=aPosition;gl_Position=uProjection*vec4(p.xyz+vec3(0.0,0.0,-6.15),1.0); }
  `;
  const fragmentSource = `
    precision highp float;
    varying vec3 vNormal;varying vec3 vPosition;varying vec3 vLocal;
    uniform vec3 uColor;uniform float uRoughness;uniform float uPores;
    float hash(vec3 p){p=fract(p*.3183099+vec3(.1,.2,.3));p*=17.0;return fract(p.x*p.y*p.z*(p.x+p.y+p.z));}
    void main(){
      vec3 n=normalize(vNormal);if(!gl_FrontFacing)n=-n;
      vec3 light=normalize(vec3(-.55,.85,1.15));vec3 fill=normalize(vec3(.75,.05,.55));
      vec3 view=normalize(vec3(0.0,0.0,6.15)-vPosition);
      float diffuse=max(dot(n,light),0.0),bounce=max(dot(n,fill),0.0);
      float rim=pow(1.0-max(dot(n,view),0.0),3.0);
      float grain=hash(floor(vLocal*620.0));float pore=step(.97,hash(floor(vLocal*103.0)));
      float material=1.0+(grain-.5)*.07-uPores*pore*.10;
      vec3 base=uColor*material*(.33+diffuse*.67+bounce*.17);
      float spec=pow(max(dot(n,normalize(light+view)),0.0),mix(65.0,12.0,uRoughness));
      base+=vec3(1.0,.92,.79)*spec*(1.0-uRoughness)*.24+vec3(.11,.095,.07)*rim;
      gl_FragColor=vec4(base,1.0);
    }
  `;

  class LoxStoneAnatomy extends HTMLElement {
    connectedCallback() {
      if(this._active)return;

      if(!this.querySelector('canvas')) { this._pending=requestAnimationFrame(()=>this.connectedCallback());return; }
      this._active=true;this._failed=false;this._contextLost=false;this._listeners=[];this._meshes=[];
      this.stage=this.querySelector('.la-stage');this.canvas=this.querySelector('canvas');
      this.range=this.querySelector('.la-range');this.button=this.querySelector('.la-toggle');
      this.reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.state={x:.14,y:-.43,e:.1};this.target={x:.14,y:-.43,e:.1};this._visible=true;this._drag=false;this._raf=0;
      try { this.initGL(); } catch(error) { this.classList.add('la-no-webgl');this._failed=true;return; }
      this.classList.add('la-ready');
      this.listen(this.stage,'pointermove',event=>this.pointer(event));
      this.listen(this.stage,'pointerdown',event=>{
        if(event.pointerType==='touch'){this._drag=true;this.stage.setPointerCapture(event.pointerId);this._touchStart={x:event.clientX,y:event.clientY};}
        this.pointer(event);
      });
      const release=()=>{this._drag=false;this._touchStart=null;};
      this.listen(this.stage,'pointerup',release);this.listen(this.stage,'pointercancel',release);
      this.listen(this.stage,'pointerleave',()=>{if(!this._drag){this.target.x=.14;this.target.y=-.43;this.requestFrame();}});
      this.listen(this.range,'input',()=>{this.target.e=Number(this.range.value)/100;this.syncControls();this.requestFrame();});
      this.listen(this.button,'click',()=>{this.target.e=this.target.e>.45?0:1;this.target.y=-.60;this.syncControls();this.requestFrame();});
      this.listen(this.reduced,'change',()=>this.requestFrame());
      this.listen(document,'visibilitychange',()=>{if(!document.hidden)this.requestFrame();else this.stop();});
      this.listen(this.canvas,'webglcontextlost',event=>{event.preventDefault();this._contextLost=true;this.stop();this.classList.remove('la-ready');this.classList.add('la-no-webgl');});
      this.listen(this.canvas,'webglcontextrestored',()=>{this.destroyGL();try{this.initGL();this._contextLost=false;this.classList.remove('la-no-webgl');this.classList.add('la-ready');this.requestFrame();}catch(error){this.classList.add('la-no-webgl');}});
      if('ResizeObserver' in window){this._resize=new ResizeObserver(()=>{this.resize();this.requestFrame();});this._resize.observe(this.stage);}
      else this.listen(window,'resize',()=>{this.resize();this.requestFrame();});
      if('IntersectionObserver' in window){this._intersection=new IntersectionObserver(entries=>{this._visible=entries[0].isIntersecting;if(this._visible)this.requestFrame();else this.stop();},{rootMargin:'100px'});this._intersection.observe(this);}
      this.resize();this.requestFrame();
    }
    listen(target,type,handler){target.addEventListener(type,handler);this._listeners.push(()=>target.removeEventListener(type,handler));}
    pointer(event){
      if(this.reduced.matches)return;
      if(event.pointerType==='touch'&&!this._drag)return;
      if(event.pointerType==='touch'&&this._touchStart&&Math.abs(event.clientY-this._touchStart.y)>Math.abs(event.clientX-this._touchStart.x)*1.3)return;
      const r=this.stage.getBoundingClientRect(),nx=clamp((event.clientX-r.left)/r.width*2-1,-1,1),ny=clamp((event.clientY-r.top)/r.height*2-1,-1,1);
      this.target.x=.14+ny*.24;this.target.y=-.48+nx*.37;

      if(!this.reduced.matches){this.target.e=clamp((nx+1)*.52,0,1);this.syncControls();}
      this.requestFrame();
    }
    syncControls(){
      this.range.value=Math.round(this.target.e*100);const expanded=this.target.e>.45;
      this.button.setAttribute('aria-pressed',String(expanded));this.button.querySelector('span').textContent=expanded?(this.dataset.labelCollapse||(document.documentElement.lang === 'en' ? "Close" : '合起')):(this.dataset.labelExpand||(document.documentElement.lang === 'en' ? "Expand" : '展開'));
      this.classList.toggle('la-expanded',this.target.e>.3);
    }
    initGL(){
      const gl=this.canvas.getContext('webgl',{alpha:true,antialias:true,premultipliedAlpha:false,powerPreference:'low-power'});
      if(!gl)throw new Error('WebGL is unavailable');this.gl=gl;
      const compile=(source,type)=>{const shader=gl.createShader(type);gl.shaderSource(shader,source);gl.compileShader(shader);if(!gl.getShaderParameter(shader,gl.COMPILE_STATUS)){gl.deleteShader(shader);throw new Error('Shader compilation failed');}return shader;};
      const vert=compile(vertexSource,gl.VERTEX_SHADER),frag=compile(fragmentSource,gl.FRAGMENT_SHADER);
      const program=gl.createProgram();gl.attachShader(program,vert);gl.attachShader(program,frag);gl.linkProgram(program);gl.deleteShader(vert);gl.deleteShader(frag);
      if(!gl.getProgramParameter(program,gl.LINK_STATUS)){gl.deleteProgram(program);throw new Error('Shader link failed');}
      this.program=program;gl.useProgram(program);
      this.locations={position:gl.getAttribLocation(program,'aPosition'),normal:gl.getAttribLocation(program,'aNormal'),projection:gl.getUniformLocation(program,'uProjection'),model:gl.getUniformLocation(program,'uModel'),color:gl.getUniformLocation(program,'uColor'),roughness:gl.getUniformLocation(program,'uRoughness'),pores:gl.getUniformLocation(program,'uPores')};
      const add=(geometry,color,part,roughness=.9,pores=.5)=>{
        const position=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,position);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(geometry.positions),gl.STATIC_DRAW);
        const normal=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,normal);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(geometry.normals),gl.STATIC_DRAW);
        this._meshes.push({position,normal,count:geometry.positions.length/3,color,part,roughness,pores});
      };
      add(archSolid(.13,.020),[.77,.735,.68],-1,.96,.7);
      add(archSolid(.17,.022),[.90,.875,.824],0,.98,1);
      add(archSolid(.13,.022),[.965,.943,.891],1,.88,.5);
      for(const radius of [.645,.535,.425,.315,.205]) {
        add(archBand(radius,.040,.0655,.002),[.64,.60,.53],1,.99,.1);
        add(archBand(radius,.027,.069,.019),[.99,.967,.911],1,.8,.25);
      }
      add(medallion(.067),[.62,.48,.29],1,.40,0);
      gl.enable(gl.DEPTH_TEST);gl.depthFunc(gl.LEQUAL);gl.clearColor(0,0,0,0);
    }
    resize(){
      if(!this.gl)return;const r=this.stage.getBoundingClientRect();if(!r.width||!r.height)return;
      const dpr=Math.min(window.devicePixelRatio||1,1.8),w=Math.round(r.width*dpr),h=Math.round(r.height*dpr);
      if(this.canvas.width!==w||this.canvas.height!==h){this.canvas.width=w;this.canvas.height=h;this.gl.viewport(0,0,w,h);}
      this._aspect=w/h;
    }
    requestFrame(){if(!this._raf&&this._active&&this._visible&&!document.hidden&&!this._failed&&!this._contextLost)this._raf=requestAnimationFrame(time=>this.frame(time));}
    stop(){if(this._raf)cancelAnimationFrame(this._raf);this._raf=0;this._lastTime=0;}
    frame(time){
      this._raf=0;if(!this._active||!this.gl||!this._visible||document.hidden)return;
      const dt=this._lastTime?Math.min(time-this._lastTime,50):16;this._lastTime=time;
      const easing=this.reduced.matches?1:1-Math.exp(-dt/140);let moving=false;
      for(const key of ['x','y','e']){this.state[key]+=(this.target[key]-this.state[key])*easing;if(Math.abs(this.target[key]-this.state[key])>.0005)moving=true;}
      const gl=this.gl,l=this.locations;gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);gl.useProgram(this.program);
      gl.uniformMatrix4fv(l.projection,false,perspective(this._aspect||1));
      const rotation=rotate(this.state.x,this.state.y,-.065),e=this.state.e;
      for(const mesh of this._meshes){

        const p=mesh.part,z=p===1?.153:p===-1?-.153:0;
        const model=multiply(rotation,translate(-p*e*.62,p*e*.12,z+p*e*.50));
        gl.uniformMatrix4fv(l.model,false,model);gl.uniform3fv(l.color,mesh.color);gl.uniform1f(l.roughness,mesh.roughness);gl.uniform1f(l.pores,mesh.pores);
        gl.bindBuffer(gl.ARRAY_BUFFER,mesh.position);gl.enableVertexAttribArray(l.position);gl.vertexAttribPointer(l.position,3,gl.FLOAT,false,0,0);
        gl.bindBuffer(gl.ARRAY_BUFFER,mesh.normal);gl.enableVertexAttribArray(l.normal);gl.vertexAttribPointer(l.normal,3,gl.FLOAT,false,0,0);gl.drawArrays(gl.TRIANGLES,0,mesh.count);
      }
      if(moving)this.requestFrame();else this._lastTime=0;
    }
    destroyGL(){if(!this.gl)return;for(const mesh of this._meshes){this.gl.deleteBuffer(mesh.position);this.gl.deleteBuffer(mesh.normal);}this._meshes=[];if(this.program)this.gl.deleteProgram(this.program);this.program=null;}
    disconnectedCallback(){
      this._active=false;this.stop();if(this._pending)cancelAnimationFrame(this._pending);
      if(this._listeners)this._listeners.forEach(remove=>remove());if(this._resize)this._resize.disconnect();if(this._intersection)this._intersection.disconnect();
      this.destroyGL();this.gl=null;this.classList.remove('la-ready');
    }
  }
  customElements.define('lox-stone-anatomy',LoxStoneAnatomy);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lox-floating-line"] && !Shopify.designMode) return;
  try {
    
if ('customElements' in window && !customElements.get('lox-line-reveal')) {
  customElements.define('lox-line-reveal', class extends HTMLElement {
    connectedCallback() {
      this.releaseListeners();
      if (this.dataset.scrollReveal !== 'true') return;
      this.mobileQuery = matchMedia('(max-width: 749px)');
      const threshold = Number(this.dataset.revealAfter) || 120;
      this.checkScroll = () => {
        if (window.Shopify?.designMode || !this.mobileQuery.matches || window.scrollY >= threshold) {
          this.dataset.revealed = 'true';
          this.releaseListeners();
        }
      };
      this.dataset.scrollReady = 'true';
      this.checkScroll();
      if (this.dataset.revealed === 'true') return;
      window.addEventListener('scroll', this.checkScroll, { passive: true });
      window.addEventListener('pageshow', this.checkScroll);
      this.mobileQuery.addEventListener('change', this.checkScroll);
    }
    disconnectedCallback() {
      this.releaseListeners();
    }
    releaseListeners() {
      if (!this.checkScroll) return;
      window.removeEventListener('scroll', this.checkScroll);
      window.removeEventListener('pageshow', this.checkScroll);
      this.mobileQuery?.removeEventListener('change', this.checkScroll);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lox-gift-catalog"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lox-gift-catalog')) {
  customElements.define('lox-gift-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      this.querySelectorAll('[data-gallery]').forEach((gallery) => {
        const track = gallery.querySelector('[data-gallery-track]');
        const slides = Array.from(track.querySelectorAll('[data-gallery-slide]'));
        const previous = gallery.querySelector('[data-gallery-previous]');
        const next = gallery.querySelector('[data-gallery-next]');
        const dots = Array.from(gallery.querySelectorAll('[data-gallery-index]'));
        const status = gallery.querySelector('[data-gallery-status]');
        if (slides.length < 2) return;
        gallery.querySelector('[data-gallery-controls]').hidden = false;
        let activeIndex = 0;
        let pendingFrame = 0;
        const update = () => {
          const left = track.getBoundingClientRect().left;
          activeIndex = slides.reduce((nearest, slide, index) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[nearest].getBoundingClientRect().left - left) ? index : nearest, 0);
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
          dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === activeIndex)));
          status.textContent = (activeIndex + 1) + ' / ' + slides.length;
        };
        const goTo = (index) => {
          const selected = slides[Math.max(0, Math.min(slides.length - 1, index))];
          const left = selected.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
          track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        previous.addEventListener('click', () => goTo(activeIndex - 1));
        next.addEventListener('click', () => goTo(activeIndex + 1));
        dots.forEach((dot) => dot.addEventListener('click', () => goTo(Number(dot.dataset.galleryIndex))));
        track.addEventListener('keydown', (event) => {
          if (event.target !== track) return;
          const indexes = { ArrowLeft: activeIndex - 1, ArrowRight: activeIndex + 1, Home: 0, End: slides.length - 1 };
          if (!(event.key in indexes)) return;
          event.preventDefault();
          goTo(indexes[event.key]);
        });
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(pendingFrame);
          pendingFrame = requestAnimationFrame(update);
        }, { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
        update();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lox-magnetic-guide"]) return;
  try {
    
if (!customElements.get('lox-product-guide')) {
 class LoxProductGuide extends HTMLElement {
  connectedCallback() {
   if (this.dataset.enhanced) return;
   this.dataset.enhanced = 'true';
   this.querySelectorAll('[data-lox-slider]').forEach(slider => {
    const track = slider.querySelector('.lox-track');
    slider.querySelectorAll('[data-lox-scroll]').forEach(button => {
     button.addEventListener('click', () => {
      const slide = track.querySelector('.lox-slide');
      const gap = parseFloat(getComputedStyle(track).gap) || 16;
      const step = slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({ left: step * Number(button.dataset.loxScroll), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
     });
    });
   });
   this.querySelectorAll('[data-lox-tabs]').forEach(tabs => {
    const buttons = [...tabs.querySelectorAll('[data-lox-tab]')];
    const panels = [...tabs.querySelectorAll('[data-lox-panel]')];
    tabs.querySelector('.lox-tab-list').setAttribute('role', 'tablist');
    const activate = index => {
     buttons.forEach((button, position) => {
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', String(position === index));
      button.tabIndex = position === index ? 0 : -1;
      panels[position].hidden = position !== index;
      panels[position].setAttribute('role', 'tabpanel');
     });
    };
    buttons.forEach((button, index) => {
     button.addEventListener('click', () => activate(index));
     button.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
      if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = buttons.length - 1;
      if (next !== undefined) {
       event.preventDefault();
       activate(next);
       buttons[next].focus();
       buttons[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
     });
    });
    activate(0);
   });
  }
 }
 customElements.define('lox-product-guide', LoxProductGuide);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lox-mit-power-bank"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lox-native-carousel')) {
  customElements.define('lox-native-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      const track = this.querySelector('[data-carousel-track]');
      if (!track) return;
      this.querySelectorAll('[data-carousel-step]').forEach(button => button.addEventListener('click', () => {
        const slide = track.querySelector('[data-carousel-slide]');
        const distance = slide ? slide.getBoundingClientRect().width + 16 : track.clientWidth;
        track.scrollBy({left: Number(button.dataset.carouselStep) * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }));
      track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        track.scrollBy({left: (event.key === 'ArrowRight' ? 1 : -1) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lox-mug-guide"]) return;
  try {
    
if (!customElements.get('lox-product-guide')) {
 class LoxProductGuide extends HTMLElement {
  connectedCallback() {
   if (this.dataset.enhanced) return;
   this.dataset.enhanced = 'true';
   this.querySelectorAll('[data-lox-slider]').forEach(slider => {
    const track = slider.querySelector('.lox-track');
    slider.querySelectorAll('[data-lox-scroll]').forEach(button => {
     button.addEventListener('click', () => {
      const slide = track.querySelector('.lox-slide');
      const gap = parseFloat(getComputedStyle(track).gap) || 16;
      const step = slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({ left: step * Number(button.dataset.loxScroll), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
     });
    });
   });
   this.querySelectorAll('[data-lox-tabs]').forEach(tabs => {
    const buttons = [...tabs.querySelectorAll('[data-lox-tab]')];
    const panels = [...tabs.querySelectorAll('[data-lox-panel]')];
    tabs.querySelector('.lox-tab-list').setAttribute('role', 'tablist');
    const activate = index => {
     buttons.forEach((button, position) => {
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', String(position === index));
      button.tabIndex = position === index ? 0 : -1;
      panels[position].hidden = position !== index;
      panels[position].setAttribute('role', 'tabpanel');
     });
    };
    buttons.forEach((button, index) => {
     button.addEventListener('click', () => activate(index));
     button.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
      if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = buttons.length - 1;
      if (next !== undefined) {
       event.preventDefault();
       activate(next);
       buttons[next].focus();
       buttons[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
     });
    });
    activate(0);
   });
  }
 }
 customElements.define('lox-product-guide', LoxProductGuide);
}

  } catch(e) { console.error(e); }
})();
})();
